import React, { Component } from 'react'

import Layout from '../../components/Layout'
import CrudHeader from '../../components/CrudHeader'
import UserToolbar from '../../components/UserToolbar'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { authorsActions, searchTableActions } from '../../actions'
import { crudListStyle } from '../../styles'

class Authors extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newAuthor, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Autores'}
          classes={classes}
          newResource={newAuthor}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'autores'}
        />
        <ListTable />
        <EditModal open={modalOpen} onClose={closeModal} />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.authors.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(authorsActions.openModal())
    },
    closeModal: () => {
      dispatch(authorsActions.closeModal())
    },
    newAuthor: author => {
      dispatch(authorsActions.newFormAuthor(author))
    },
    resetState: () => {
      dispatch(authorsActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Authors))



// WEBPACK FOOTER //
// ./src/containers/Authors/index.js